import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDesignContext } from '../../design-provider';
import { classNames } from '../utils/classnames';
import { AspectRatioView } from './aspect-ratio-view';
import { Price } from './price';
import { getImageSrc } from '../utils/get-image-src';
import { getFirstImage } from '../utils/get-first-image';
import { Image } from '../../common/components/image';
export var CustomGoodsCard = function CustomGoodsCard(props) {
  var className = props.className,
    _props$goods = props.goods,
    goods = _props$goods === void 0 ? {} : _props$goods,
    colorImage = props.colorImage;
  var _useDesignContext = useDesignContext(),
    local = _useDesignContext.local,
    designOnLink = _useDesignContext.designOnLink,
    productDefaultImage = _useDesignContext.productDefaultImage;
  var linkPath = designOnLink({
    linkType: 'product',
    linkParams: {
      name: goods.cskuName,
      id: goods.csku,
      csku: goods.csku
    }
  });
  var sellText = useMemo(function () {
    /** 商品已下架 */
    if ((goods === null || goods === void 0 ? void 0 : goods.onShelves) === 2) {
      return local.goods.unShelve;
    }
    /** 商品预售中 */
    if (goods === null || goods === void 0 ? void 0 : goods.sellFlag) {
      return local.goods.preSale;
    }
    /** 商品已售罄 */
    if (goods === null || goods === void 0 ? void 0 : goods.soldOutStatus) {
      return local.goods.soldOut;
    }
    return '';
  }, [goods]);
  var hasLinePrice = goods.originPrice && goods.salePrice && +goods.originPrice > +goods.salePrice;
  return _jsxs("a", Object.assign({
    className: classNames('group relative w-full  rounded bg-white cursor-pointer', 'cq-pc:hover:border-[#4C4C4C]', 'block', className),
    href: linkPath
  }, {
    children: [_jsx(AspectRatioView, Object.assign({
      className: classNames('w-full rounded overflow-hidden')
    }, {
      children: _jsx(LazyLoadImage, {
        className: classNames('w-full h-full', {
          'opacity-50': sellText
        }),
        src: getImageSrc(getFirstImage(goods.customPictures, productDefaultImage))
      })
    })), _jsx("div", Object.assign({
      className: classNames('w-full overflow-hidden flex justify-center')
    }, {
      children: colorImage && (colorImage.mobile || colorImage.web) && _jsx(Image, {
        src: colorImage
      })
    })), _jsxs("div", Object.assign({
      className: classNames('p-3 pt-0 w-full', 'cq-pc:p-5 cq-pc:pt-0')
    }, {
      children: [_jsx("div", Object.assign({
        className: classNames('mt-1 text-sm font-medium text-ahaa-black-1 line-clamp-2 h-10', 'cq-pc:h-11 cq-pc:text-base')
      }, {
        children: goods.cskuName || goods.name
      })), _jsx("div", Object.assign({
        className: classNames('flex mt-1', 'cq-pc:mt-2')
      }, {
        children: _jsxs("div", Object.assign({
          className: classNames('flex-1 flex flex-col', 'cq-pc:flex-row cq-pc:items-center cq-pc:line-clamp-1')
        }, {
          children: [_jsx(Price, Object.assign({
            className: classNames('mr-1 text-base font-medium text-ahaa-black-7', 'cq-pc:text-lg', {
              'text-ahaa-red-1': hasLinePrice
            }),
            symbolClassName: 'text-xs align-middle',
            priceClassName: 'align-middle'
          }, {
            children: goods.salePrice
          })), hasLinePrice ? _jsx(Price, Object.assign({
            className: classNames('text-xs text-ahaa-black-8', 'cq-pc:text-sm'),
            lineThrough: true
          }, {
            children: goods.originPrice
          })) : _jsx("div", {
            className: classNames('h-4', 'pc:h-0')
          })]
        }))
      }))]
    }))]
  }));
};